import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAuthSession } from 'aws-amplify/auth';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getTenantFromUrl } from '../../utils/tenant';
import './Redirect.scss';

export default function Redirect() {
  const navigate = useNavigate();
  const isRedwoodSeed = getTenantFromUrl() === 'redwoodseed';

  useEffect(() => {
    async function validateAndRedirect() {
      try {
        await fetchAuthSession(); // Validate session
        const portal = new URLSearchParams(window.location.search).get("portal");
        const tenant = getTenantFromUrl();
        const tenantQuery = `portal-switch=1&tenant=${tenant}`;

        if (portal === 'enterprise') {
          if(isRedwoodSeed) {
            window.location.href = `${process.env.REACT_APP_ENTERPRISE_HOSTNAME}?${tenantQuery}`;
          } else {
            window.location.href = `${process.env.REACT_APP_INITIO_ENTERPRISE_HOSTNAME}?${tenantQuery}`;
          }
        } else if (portal === 'admin') {
          if(isRedwoodSeed) {
            window.location.href = `${process.env.REACT_APP_REDWOODSEED_ADMIN_HOSTNAME}?${tenantQuery}`;
          } else {
            window.location.href = `${process.env.REACT_APP_ADMIN_HOSTNAME}?${tenantQuery}`;
          }
        } else {
          navigate('/portal-selection');
        }
      } catch {
        navigate('/login');
      }
    }

    validateAndRedirect();
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      className="Redirect"
    >
      <div className="spinner-container">
        <div className="dots-circle-spinner" />
      </div>
      <Typography variant="h6" sx={{ mt: 3, fontWeight: 500, color: '#333' }}>
        Redirecting to your portal...
      </Typography>
    </Box>
  );
}
